export const RESOURCES = {
  videos: {
    label: "YouTube Videos",
    endpoint: "/videos",
    listParams: "?all=true",
    titleField: "title",
    subField: "description",
    autofillYoutube: true,
    empty: { title: "", description: "", youtube_id: "", thumbnail: "", order: 0, published: true },
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "description", label: "Description", type: "textarea" },
      { key: "youtube_id", label: "YouTube Video ID", type: "text", hint: "e.g. dQw4w9WgXcQ (leave blank for placeholder)" },
      { key: "thumbnail", label: "Custom Thumbnail URL", type: "text" },
      { key: "order", label: "Order", type: "number" },
      { key: "published", label: "Published", type: "checkbox" },
    ],
  },
  breeding: {
    label: "Breeding Projects",
    endpoint: "/breeding",
    titleField: "species",
    subField: "summary",
    empty: { species: "", category: "", status: "Planned", start_date: "", tank: "", pair_setup: "", summary: "", notes: "", image: "", is_sample: false, order: 0 },
    fields: [
      { key: "species", label: "Species", type: "text", required: true },
      { key: "category", label: "Category", type: "select", options: ["Apistogramma", "Rams", "Other tropical cichlids", "Community breeding projects", "Fry development", "Grow-out tanks"] },
      { key: "status", label: "Status", type: "select", options: ["Planned", "In Progress", "Fry", "Grow-out", "Paused", "Success"] },
      { key: "start_date", label: "Start Date", type: "text" },
      { key: "tank", label: "Tank", type: "text" },
      { key: "pair_setup", label: "Pair / Setup", type: "text" },
      { key: "summary", label: "Summary", type: "textarea" },
      { key: "notes", label: "Notes", type: "textarea" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "order", label: "Order", type: "number" },
      { key: "is_sample", label: "Mark as sample", type: "checkbox" },
    ],
  },
  journal: {
    label: "Journal Posts",
    endpoint: "/journal",
    listParams: "?all=true",
    titleField: "title",
    subField: "excerpt",
    empty: { title: "", excerpt: "", body: "", cover_image: "", category: "Update", is_sample: false, published: true },
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "category", label: "Category", type: "text" },
      { key: "excerpt", label: "Excerpt", type: "textarea" },
      { key: "body", label: "Body", type: "textarea", big: true, hint: "Separate paragraphs with a blank line." },
      { key: "cover_image", label: "Cover Image URL", type: "text" },
      { key: "published", label: "Published", type: "checkbox" },
      { key: "is_sample", label: "Mark as sample", type: "checkbox" },
    ],
  },
  fishroom: {
    label: "Fish Room Updates",
    endpoint: "/fishroom",
    titleField: "title",
    subField: "caption",
    empty: { title: "", caption: "", image: "", stage: "", is_sample: false, order: 0 },
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "caption", label: "Caption", type: "textarea" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "stage", label: "Stage", type: "select", options: ["Current Tanks", "Rack Build", "New Tanks", "Progress", "Breeding Setups"] },
      { key: "order", label: "Order", type: "number" },
      { key: "is_sample", label: "Mark as sample", type: "checkbox" },
    ],
  },
  testlab: {
    label: "Test Lab Products",
    endpoint: "/testlab",
    titleField: "name",
    subField: "manufacturer",
    empty: { name: "", manufacturer: "", category: "", my_review: "", community_tester: "", community_review: "", test_duration: "", pros: [], cons: [], score: null, verdict: "", video_links: [], image: "", status: "coming_soon", is_sample: false },
    fields: [
      { key: "name", label: "Product Name", type: "text", required: true },
      { key: "manufacturer", label: "Manufacturer", type: "text" },
      { key: "category", label: "Category", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["coming_soon", "testing", "published"] },
      { key: "test_duration", label: "Test Duration", type: "text" },
      { key: "my_review", label: "My Review", type: "textarea" },
      { key: "community_tester", label: "Community Tester", type: "text" },
      { key: "community_review", label: "Community Review", type: "textarea" },
      { key: "pros", label: "Pros", type: "tags", hint: "Comma-separated" },
      { key: "cons", label: "Cons", type: "tags", hint: "Comma-separated" },
      { key: "score", label: "Score", type: "number" },
      { key: "verdict", label: "Final Verdict", type: "textarea" },
      { key: "video_links", label: "Video Links", type: "tags", hint: "Comma-separated URLs" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "is_sample", label: "Mark as sample", type: "checkbox" },
    ],
  },
};
